'use strict';

var Joi = require('joi');
var experimentsSchema_model = require('../utils/experimentsSchema.model.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var SignupPageAbandon = Joi__default["default"].object().keys({
  page_number: Joi__default["default"].number().min(1).required().description('Step in Onboarding Wizard'),
  experiments: experimentsSchema_model,
  name: Joi__default["default"].string().optional().description('Creator Name'),
  username: Joi__default["default"].string().optional().description('Creator Username'),
  publisher_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).optional().description('Publisher user logged into their account from')
}).description('Fires when a user navigates away from a step without completing it. This will fires when the step component unmounts.').meta({
  name: 'SignupPageAbandon',
  filename: 'signup:page_abandon.model'
});
var SignupPageAbandon$1 = SignupPageAbandon;

module.exports = SignupPageAbandon$1;
//# sourceMappingURL=page_abandon.model.js.map
